import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styles from './LicensingScreenContainer.module.scss';

import useGTMEvents from '../../../common/hooks/useGTMEvents';
import articleLicensingEventConfigs from '../helpers/articleLicensingGTMEvents';

const LicensingScreenContainer = () => {
  const location = useLocation();
  const isNotConfirmationPage = !location.pathname.includes('/confirmation');
  const [formValues, setFormValues] = useState({});
  const [newspost, setNewspost] = useState({});

  const pushEvent = useGTMEvents(articleLicensingEventConfigs);

  return (
    <main className={`${styles.container} skip-nav-target`}>
      {isNotConfirmationPage && (
        <section className={styles.licensingGeneralInfo}>
          <h1 className="display-heading-03">License an article</h1>
          <p className={styles.description}>
            Obtain permission to Industry Dive’s original content within acceptable use{' '}
            <a href="https://www.industrydive.com/article-licensing-policy" target="_blank" rel="noopener noreferrer">
              guidelines
            </a>.
          </p>
        </section>
      )}
      <Outlet context={{
        formValues,
        newspost,
        pushEvent,
        setFormValues,
        setNewspost,
      }}
      />
    </main>
  );
};

export default LicensingScreenContainer;
